// index.js

import { combineReducers } from 'redux';
import authReducer from './authReducer';
import masterGameReducer from './masterGameReducer';
import loadingReducer from './loadingReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  masterGameReducer,
  loadingReducer
});

export default rootReducer;
